import { AType, EType, summon } from "@silversea-ssc/functional-support"
import { brandFromPredicate, brandString, Guards } from "@ssc-booking/functional-support"
import { NonEmptyString } from "io-ts-types"
import { functionExt as Fx } from "@ssc-booking/functional-support"

const realSuiteNumberRegex = /^\d{2,4}$/
const type = brandFromPredicate(NonEmptyString, (x) => realSuiteNumberRegex.test(x), "RealSuiteNumber")

export const RealSuiteNumber = /* @__PURE__ */ brandString(type, (fc) =>
    fc.stringOf(fc.constantFrom("0", "1", "2", "3", "4", "5", "6", "7", "8", "9"), { minLength: 2, maxLength: 4 }),
)
export type RealSuiteNumber = AType<typeof RealSuiteNumber>
export type RealSuiteNumberEncoded = EType<typeof RealSuiteNumber>

export const GuaranteedSuiteNumber = /* @__PURE__ */ summon((F) =>
    F.stringLiteral("GTY", {
        FastCheckURI: (_x, { fastCheck }) => fastCheck.constantFrom("GTY").map((x: string) => x as "GTY"),
    }),
)
export type GuaranteedSuiteNumber = AType<typeof GuaranteedSuiteNumber>
export type GuaranteedSuiteNumberEncoded = EType<typeof GuaranteedSuiteNumber>

const _SuiteNumber = /* @__PURE__ */ summon((F) =>
    F.union([GuaranteedSuiteNumber(F), RealSuiteNumber(F)])(
        [Guards.is(GuaranteedSuiteNumber), Guards.is(RealSuiteNumber)],
        "SuiteNumber",
    ),
)
export type SuiteNumber = AType<typeof _SuiteNumber>
export type SuiteNumberEncoded = EType<typeof _SuiteNumber>

const guaranteed: SuiteNumber = "GTY"
export const SuiteNumber = Object.assign(_SuiteNumber, {
    guaranteed,
    match:
        <T>(real: (real: RealSuiteNumber) => T, guaranteed: () => T) =>
        (suiteNumber: SuiteNumber): T => {
            if (RealSuiteNumber.strictType.is(suiteNumber)) return real(suiteNumber)
            if (GuaranteedSuiteNumber.strictType.is(suiteNumber)) return guaranteed()
            return Fx.assertExhaustive(suiteNumber)
        },
})
